export default {"src":"/_next/static/media/integration-active-icon.873fafe0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};